export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/fission/ordinary' */ './Ordinary'
  );
